export default __webpack_public_path__ + "static/io-a5cb8dd8c8d6ec789e1f87e75d3d76cb.svg";